<template>
  <div class="mega-menu container py-0">
    <v-row>
      <v-col cols="3" class="pa-0">
        <div class="mega-menu-title categories">Categories</div>
        <div class="mega-menu-container categories">
          <v-row>
            <v-col cols="12" sm="6">
              <a
                href="#"
                v-for="item in categories.slice(0, 6)"
                :key="item"
                @mouseover="setCategory(item, $event)"
                >{{ item }}</a
              >
            </v-col>
            <v-col cols="12" sm="6">
              <a
                href="#"
                v-for="item in categories.slice(6, 12)"
                :key="item"
                @mouseover="setCategory(item, $event)"
                >{{ item }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="3" class="pa-0">
        <div class="mega-menu-title materials">
          <img
            :src="require('@/assets/materials.svg')"
            class="mr-1"
            alt="logo"
          />
          Materials
        </div>
        <div class="mega-menu-container materials">
          <v-row>
            <v-col cols="12" sm="6">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Materials.slice(0, 7)"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
            <v-col cols="12" sm="6">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Materials.slice(7, 13)"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="3" class="pa-0">
        <div class="mega-menu-title instruments">
          <img
            :src="require('@/assets/instruments.svg')"
            class="mr-1"
            alt="logo"
          />
          Instruments
        </div>
        <div class="mega-menu-container instruments">
          <v-row>
            <v-col cols="12">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Instruments"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="3" class="pa-0">
        <div class="mega-menu-title equipment">
          <img
            :src="require('@/assets/equipment.svg')"
            class="mr-1"
            alt="logo"
            width="14"
          />
          Equipment
        </div>
        <div class="mega-menu-container equipment">
          <v-row>
            <v-col cols="12">
              <a
                @click="searchProducts(item)"
                v-for="(item, index) in selected.Equipment"
                :key="index"
                >{{ item.name }}</a
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MegaMenu",
  data: () => ({
    selectedCategory: "Restoratives"
  }),
  computed: {
    selected() {
      return this.category[this.selectedCategory];
    },
    ...mapState({
      category: state => state.product.category,
      categories: state => state.product.categories
    })
  },
  methods: {
    setCategory(item, e) {
      e.preventDefault();
      this.selectedCategory = item;
    },
    searchProducts(item) {
      this.$store.dispatch("product/SEARCH_BY_SUBCATEGORY_ID", item.id);
      this.evtSelectCategory(item.id);
      this.$emit("close");
      this.$router
        .push({
          name: "search-category-subcategory",
          params: {
            category: this.selectedCategory
              .trim()
              .replaceAll(" ", "-")
              .toLowerCase(),
            subcategory: item.name
              .trim()
              .replaceAll(" ", "-")
              .toLowerCase(),
            id: item.id
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss" src="./MegaMenu.scss"></style>
